import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-507d1dfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container rel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "26",
  src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_pure_login_text_1.png",
  alt: ""
}, null, -1))

import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import { bury } from '@/util/useBury'
import { useRouter } from 'vue-router'
import { TaEvent, taTrack } from '@/util/buryingPoint'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const goSignup = () => {
  bury('ALL_Click_Register')
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: '1688_login'
    }
  })
  router.push('/signup')
}
const show = ref(true)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex-cen flex-ter content abs" }, [
      _hoisted_2,
      _createElementVNode("img", {
        onClick: goSignup,
        class: "login cursor-pt",
        height: "36",
        width: "120",
        src: "https://static-s.theckb.com/BusinessMarket/Client/national_login_btn.png",
        alt: ""
      })
    ])
  ]))
}
}

})